import { Component } from 'react';
import {Row, Col} from 'react-bootstrap';
import {connect} from 'react-redux';
import MultiSelect from '../../common/form/multi-select';
import IgniteDataTable from '../../common/datatable';
import Button from '../../common/button';

class OutletGroupDetails extends Component {
  constructor(props) {
    super(props);
    const {rowClick, removeGroupButtonClick} = props;

    this.groupColumns = [
      {
        title: 'ID',
        prop: 'id',
        width: '100',
        onClick: rowClick,
      },
      {
        title: 'Group Name',
        prop: 'name'
      }
    ];

    this.actions = [
      {
        label: 'Remove',
        callback: (row) => {
          removeGroupButtonClick(row);
        }
      }
    ];

    this.addButtonDisabled = () => this.props.formData.length <= 0;
  }

  render() {
    const {
      outletsGroups,
      allGroups,
      formData,
      addToGroupButtonClick
    } = this.props;

    const outletsGroupIds = outletsGroups.map(group => (
      `${group.id}`
    ));

    const allGroupsList = allGroups.filter(group => (
      !(outletsGroupIds.includes(group.id))
    )).map(group => ({
      label: `${group.id} - ${group.attributes.name}`,
      value: group.id
    }));

    return (
      <div className='fluid'>
        <Row>
          <Col md={9}>
            <MultiSelect
              model={'deep.admin_outlet_view.groups'}
              data={allGroupsList}
              value={formData}
            />
          </Col>
          <Col md={3}>
            <Button
              disabled={this.addButtonDisabled()}
              onClick={addToGroupButtonClick}
            >
              Add to group
            </Button>
          </Col>
        </Row>
        <IgniteDataTable
          columns={this.groupColumns}
          tableClass='ignite-table mg-top-10'
          data={outletsGroups}
          actions={this.actions}
          hasAttributes={false}
        />
      </div>
    );
  }
}

export default connect()(OutletGroupDetails);
